import { FC } from 'lib/component-utils'
import { ISO8601DateTimeString } from 'lib/dto'
import { useIntl } from 'lib/intl-utils'

type Props = {
  dateTime: ISO8601DateTimeString | Date | null | undefined
  options?: Intl.DateTimeFormatOptions
  fallback?: JSX.Element
}

const Time: FC<Props, 'time'> = ({ dateTime, options, fallback, ...rest }) => {
  const { format } = useIntl()

  return dateTime != null ? (
    <time dateTime={dateTime.toString()} {...rest} suppressHydrationWarning>
      {format.date(dateTime, options)}
    </time>
  ) : (
    fallback ?? null
  )
}

export default Time
